export const PHONE_DISPLAY = "077-8504401";
export const PHONE_INTL_DISPLAY = "+94 77 850 4401";
export const PHONE_TEL = "tel:+94778504401";
export const WHATSAPP_URL = "https://wa.me/94778504401";
export const INSTAGRAM_HANDLE = "@cakesalot_";
export const INSTAGRAM_URL = "https://www.instagram.com/cakesalot_";
export const INSTAGRAM_DM_URL = "https://ig.me/m/cakesalot_";

export const GALLERY = [
    {
        src: "/images/cake-amma-box.jpg",
        tag: "Celebration box",
        alt: 'Amma buttercream cake with five matching cupcakes in a pink gift box',
    },
    {
        src: "/images/cake-bento.jpg",
        tag: "Bento cakes, boxed with love",
        alt: "Three pastel bento cakes in takeout boxes — pink, yellow and purple",
    },
    {
        src: "/images/cake-grad.jpg",
        tag: "Graduations",
        alt: 'Graduation cake with "You did it!" piped in frosting beside a cartoon character',
    },
    {
        src: "/images/cake-wedding.jpg",
        tag: "Weddings",
        alt: "Three-tier ivory wedding cake with sugar roses and gold initials",
    },
];

export const REVIEWS = [
    {
        text: "Thank you for the incredible birthday cake! It was not only beautiful but tasted absolutely delicious too.",
        author: "Mishaya",
    },
    {
        text: "Literally everyone asked me where I got the cake from and said it was delicious!",
        author: "Happy customer",
    },
    {
        text: "The best thing I ever had in a while.",
        author: "Sohan",
    },
    {
        text: "Literally so good! I'm def buying more.",
        author: "Ari",
    },
    {
        text: "Thank you so much for the yummy cupcakes. Will definitely order from you again. They were so pretty!",
        author: "Nichola",
    },
];
